import _extends from "@babel/runtime/helpers/extends";
import { proxy, snapshot, useProxy } from 'valtio';
export var theme = proxy({
  colors: {
    primaryColor: '#ef6c00',
    warningColor: '#ff9800',
    dangerColor: '#f44336',
    successColor: '#4caf50',
    infoColor: '#2979ff',
    grayColor: '#999999',
    whiteColor: '#fff',
    roseColor: '#e91e63'
  }
});
export var setTheme = function (customTheme) {
  theme.colors = _extends({}, theme.colors, customTheme);
};
export var useTheme = function () {
  return useProxy(theme).colors;
};
export var getTheme = function () {
  return snapshot(theme).colors;
};